import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const HomePage = () => {
    const navigate = useNavigate();

    const selectorProfile = createSelector(
        state => state.Profile,
        profile => ({ establishmentActive: profile.establishmentActive }),
    );
    const { establishmentActive } = useSelector(selectorProfile);
    const establishmentActiveId = establishmentActive?.item?._id || '';

    const MODULE_CARDS = [
        {
            name: 'Fiscalización',
            description: 'Panel de fiscalización normativa',
            icon: 'icon-clipboard-check',
            link: '/fiscalizacion/dashboard',
        },
        {
            name: 'Combustible',
            description: 'Gestión de suministro de combustible',
            icon: 'icon-fuel',
            link: '/establishment/summary/fuel/' + establishmentActiveId,
        },
        {
            name: 'Gestión de EPP',
            description: 'Equipos de protección personal',
            icon: 'icon-shirt',
            link: '/supply/ppe/summary',
        },
        {
            name: 'Derechos de Agua',
            description: 'Panel de derechos de agua',
            icon: 'icon-droplets',
            link: '/water-rights/dashboard',
        },
        {
            name: 'Parámetros Ambientales',
            description: 'Variables de medio ambiente',
            icon: 'icon-activity',
            link: '/environment/variable',
        },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        {MODULE_CARDS.map((card, index) => (
                            <Col key={index} xs={12} sm={6} md={4} xl={2} className="mb-3">
                                <Card
                                    className="text-center card-animate h-100"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => navigate(card.link)}
                                >
                                    <CardBody className="p-4 d-flex flex-column align-items-center justify-content-center gap-2">
                                        <i className={`${card.icon} fs-1`}></i>
                                        <h5 className="card-title mb-0">{card.name}</h5>
                                        <p className="text-muted fs-13 mb-0">{card.description}</p>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default HomePage;
